import type {
  MidiInstrument,
  MidiKeySignature,
  MidiTempo,
  MidiTimeSignature,
} from "@midi-fantom-utils/midi-core";

export const formatTempos = (
  tempos: ReadonlyArray<MidiTempo>
): ReadonlyArray<string> => tempos.map((t) => formatTempo(t));

export const formatTempo = (tempo: MidiTempo): string =>
  `${Math.ceil(tempo.bpm)} (BPM), с такта ${tempo.ticks}`;

export const formatTimeSignatures = (
  timeSignatures: ReadonlyArray<MidiTimeSignature>
): ReadonlyArray<string> => timeSignatures.map((ts) => formatTimeSignature(ts));

export const formatTimeSignature = (ts: MidiTimeSignature): string =>
  `${ts.timeSignature.join("/")}, с такта ${ts.ticks}`;

export const formatKeySignatures = (
  keySignatures: ReadonlyArray<MidiKeySignature>
): ReadonlyArray<string> => keySignatures.map((ks) => formatKeySignature(ks));

export const formatKeySignature = (ks: MidiKeySignature): string =>
  `${ks.key} ${ks.scale}, с такта ${ks.ticks}`;

export const formatInstrument = (instrument: MidiInstrument): string =>
  `${instrument.number}, ${instrument.name}, ${instrument.family.toLocaleUpperCase()}`;

export const formatDurationWithMs = (seconds: number): string => {
  if (!isFinite(seconds) || seconds < 0) return "00:00:00.000";

  const totalSecs = Math.floor(seconds);
  const ms = Math.round((seconds - totalSecs) * 1000);
  const hours = Math.floor(totalSecs / 3600);
  const minutes = Math.floor((totalSecs % 3600) / 60);
  const secs = totalSecs % 60;

  const pad = (n: number, digits = 2): string => n.toString().padStart(digits, "0");

  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}.${pad(ms, 3)}`;
};